import { useQuery } from 'react-query';

import { useToasts } from '@savgroup-front-common/core/molecules/NotificationsProvider';
import { SF_SERVICE } from '@savgroup-front-common/types';
import { SellerService } from '@/api';

interface UseGetSellerConfigurationSalesforceArgs {
  sellerId?: string;
  service?: SF_SERVICE;
}

export const GetSellerConfigurationSalesforceQuery =
  'getSellerConfigurationSalesforceQuery';

const useGetSellerConfigurationSalesforce = ({
  sellerId,
  service,
}: UseGetSellerConfigurationSalesforceArgs) => {
  const { pushErrors } = useToasts();

  const { data: sellerConfigurationSalesforce, isLoading } = useQuery(
    [GetSellerConfigurationSalesforceQuery, { sellerId }],
    async () => {
      if (!sellerId || !service) {
        return undefined;
      }

      const response =
        await SellerService.getSellerConfigurationSalesforceQuery({
          sellerId,
          service,
        });

      if (response.failure) {
        pushErrors(response.errors);

        return undefined;
      }

      return response.value;
    },
    {
      staleTime: Infinity,
    },
  );

  return { sellerConfigurationSalesforce, isLoading };
};

export default useGetSellerConfigurationSalesforce;
